import { render, staticRenderFns } from "./AppSwitchUserDialog.vue?vue&type=template&id=e0c22c2c&scoped=true&"
import script from "./AppSwitchUserDialog.vue?vue&type=script&lang=ts&"
export * from "./AppSwitchUserDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AppSwitchUserDialog.vue?vue&type=style&index=0&id=e0c22c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c22c2c",
  null
  
)

export default component.exports